import React from 'react'
import { ImagePaths } from '@/utils/constants'
import useFallbackImage from '@/hooks/useFallbackImage'
import classNames from 'classnames'

interface RemoteImageProps {
  image_url: string | null
  alt_name: string | null
  style_classes: string | null
}

function RemoteImage({ image_url, alt_name, style_classes }: RemoteImageProps) {
  const { imageUrl, handleImageLoaded, handleImageError, isLoading } = useFallbackImage(
    ImagePaths.DEFAULT_PLACEHOLDER,
    image_url
  )

  return (
    <img
      className={classNames(style_classes, { 'animate-pulse': isLoading })}
      src={imageUrl}
      onLoad={handleImageLoaded}
      onError={handleImageError}
      alt={alt_name ?? 'placeholder image'}
    />
  )
}

export default RemoteImage
